import React from 'react';

import { Text, Modal, Button } from '@unimed-fesp/components';

import ParametrizacaoContratantes from '../../components/organisms/ParametrizacaoContratantes';

import { ContentWrapper, FooterWrapper, BodyWrapper } from './styles';

import theme from '../../styles/theme';

import ModalCancelActionFooter from './ModalCancelActionFooter';

const Parametros = ({
  openModalCancelAction,
  handleCancelarCadastro,
  handleModalCancelAction,
  display,
  isButtonDisabled,
  handlePreviousTab,
  handleActiveTab,
}) => {
  return (
    <ContentWrapper display={display}>
      <BodyWrapper
        paddingRight="70px"
        paddingLeft="70px"
        paddingBottom="49px"
        height="fit-content"
      >
        <ParametrizacaoContratantes idUsuario={0} />
      </BodyWrapper>
      <FooterWrapper>
        <Button
          tipo="tertiary"
          justifyCenter
          alignCenter
          type="button"
          width={100}
          font="16px unimed_slabregular"
          onClick={() => handlePreviousTab('parametrizacao')}
        >
          voltar
        </Button>
        <Button
          tipo="primary"
          justifyCenter
          type="button"
          disabled={isButtonDisabled}
          width={100}
          font="16px unimed_slabregular"
          onClick={() => handleActiveTab('dadosAcesso')}
        >
          avançar
        </Button>
      </FooterWrapper>
      <Modal
        tipo="warning"
        onClick={handleModalCancelAction}
        isOpen={openModalCancelAction}
        footer={
          <ModalCancelActionFooter
            onClick={handleModalCancelAction}
            onClickOk={handleCancelarCadastro}
          />
        }
      >
        <Text
          center
          text="Ao cancelar o cadastro do usuário, você perderá os dados não salvos. Deseja continuar?"
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
    </ContentWrapper>
  );
};

export default Parametros;
